import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 3a1 1 0 0 1 0 2h-16a1 1 0 1 1 0 -2z","key":"svg-0"}],["path",{"d":"M20 19a1 1 0 0 1 0 2h-16a1 1 0 0 1 0 -2z","key":"svg-1"}],["path",{"d":"M16 8a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z","key":"svg-2"}]]

const IconLayoutDistributeHorizontalFilled = createReactComponent('filled', 'layout-distribute-horizontal-filled', 'LayoutDistributeHorizontalFilled', __iconNode);

export default IconLayoutDistributeHorizontalFilled;